export default __webpack_public_path__ + "static/media/turkey.ca333d30.png";